import React from "react";
export const Card = ({ comments, showCustomIcon, iconUrl, slideNumber, }) => (React.createElement("div", { className: "m34-card" },
    React.createElement(IconWrapper, { showCustomIcon: showCustomIcon, iconUrl: iconUrl, slideNumber: slideNumber }),
    React.createElement("h5", { className: "h5-semi-bold", dangerouslySetInnerHTML: { __html: comments } })));
const IconWrapper = ({ showCustomIcon, iconUrl, slideNumber, }) => {
    if (showCustomIcon) {
        return (React.createElement("div", { className: "m34-card__icon" }, iconUrl && React.createElement("img", { src: iconUrl, alt: "" })));
    }
    return React.createElement("div", { className: "m34-card__icon" },
        React.createElement("div", { className: "m34-card__icon-number" }, slideNumber));
};
